module.exports = __webpack_public_path__ + "img/new-logo.1d3ee357.png";